// eslint-disable-next-line unicorn/prefer-node-protocol
import { Buffer } from 'buffer'

import pako from 'pako'

export const gzip = (body: any) => {
  // @ts-expect-error
  return Buffer.from(pako.gzip(JSON.stringify(body), { to: 'string' })).toString('base64')
}

export const gunzip = (body: any) => {
  return JSON.parse(pako.ungzip(Buffer.from(body, 'base64'), { to: 'string' }))
}
